import axios from 'axios'
import interceptors from './interceptors'

let API_BASE_URL
// for testing purposes
API_BASE_URL = process.env.API_BILLMA || 'https://billma.tadaima.studio/api-systema'
export class BillmaHttpClient {
  constructor () {
    this.client = axios.create({ baseURL: API_BASE_URL })

    interceptors.createRequestInterceptorBillmma(this)
    interceptors.createResponseInterceptor(this)
  }

  request (method, url, data, config) {
    return new Promise((resolve, reject) => {
      this.client[method](url, data, config || {})
        .then(response => {
          resolve(response.data)
        }).catch(error => {
          if (error?.response?.status === 401) {
            window.location.href = '/logout'
          } else {
            reject(error)
          }
        })
    })
  }

  get (url, data, config) {
    return this.request('get', url, data, config)
  }

  post (url, config) {
    return this.request('post', url, config)
  }

  put (url, config) {
    return this.request('put', url, config)
  }

  patch (url, config) {
    return this.request('patch', url, config)
  }

  delete (url, config) {
    return this.request('delete', url, config)
  }

  getFile(url) {
    return fetch(`${API_BASE_URL}/${url}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('mavAuth')}`
      }
    }).then((response) => {
      return response.blob()
    })
  }
}

const billmaHttpClient = new BillmaHttpClient()

export default billmaHttpClient
